module.exports = __webpack_public_path__ + "img/US_Cost_ua.1948d1f2.webp";